//@ts-ignore
import React from 'react';
import { useEffect, useState } from 'react';
import { X, ArrowRight, Calendar, IdCard } from 'lucide-react';
import { TButtonBgProps, TourType } from './types';
import { Box, Button } from 'src/components/mui';
import { useMediaQuery } from '@mui/material';
import { Icon } from '../icon/Icon';
import {
  HintArrowStyle,
  HintBoxStyle,
  SearchButtonSpanStyle,
  ToggleNavBoxStyle,
  ToggleNavButtonStyle,
} from './styles';

export const ButtonBg = ({
  menuOpen,
  chatToken,
  tour,
  host,
  menuOpenForDevice,
  tourType,
  MenuHintOn,
  translation,
  showExpand,
  tourEmail,
  showCustomButton,
  getInTouchHintOn,
  toggleContactPopup,
  appointmentsHintOn,
  toggleAppointmentsModal,
  handleCustomButton,
  toggleNav,
  menu,
  menuColors,
  openOnHover,
}: TButtonBgProps) => {
  const [ButtonBgState, setButtonBgState] = useState({
    MenuHintOn: false,
    getInTouchHintOn: false,
    appointmentsHintOn: false,
  });

  const mobile = useMediaQuery('(max-width: 768px)');
  const lendscape = useMediaQuery('(orientation: landscape) and (max-width: 900px)');

  useEffect(() => {
    setButtonBgState((prevState) => ({
      ...prevState,
      MenuHintOn: MenuHintOn,
      getInTouchHintOn: getInTouchHintOn,
      appointmentsHintOn: appointmentsHintOn,
    }));
  }, [MenuHintOn, getInTouchHintOn, appointmentsHintOn]);

  const closeHint = (name: string) =>
    setButtonBgState((prevState) => ({ ...prevState, [name]: false }));

  return (
    <Box
      sx={{
        position: 'absolute',
        right: menuOpen ? '250px' : 0,
        marginTop: mobile ? '60px' : lendscape ? '50px' : '80px',
        transition: 'all 0.3s ease',
        zIndex: 10,
        top: 0,
      }}
    >
      {(!chatToken || (chatToken && host)) &&
        tour?.menuEnabled &&
        !menuOpenForDevice &&
        tourType !== TourType.Game && (
          <Box>
            {ButtonBgState.MenuHintOn && (
              <Box sx={HintBoxStyle}>
                <Box component="span" fontSize="12px">
                  {(translation && translation?.menuAppointmentTooltip) || 'Menu'}
                </Box>
                <ArrowRight
                  size={16}
                  style={HintArrowStyle}
                />
              </Box>
            )}
            <Box
              sx={ToggleNavBoxStyle(showExpand, menuColors?.fon)}
              onMouseEnter={!menuOpen && openOnHover ? toggleNav : undefined}
              onClick={toggleNav}
            >
              <Button sx={ToggleNavButtonStyle}>
                <Box
                  component="span"
                  sx={{
                    width: '20px',
                    height: '14px',
                    display: 'inline-block',
                    position: 'relative',
                  }}
                >
                  <Box
                    component="span"
                    sx={SearchButtonSpanStyle(menuOpen, menuColors?.searchButtonColor)}
                  />
                </Box>
              </Button>
            </Box>
          </Box>
        )}
      {!chatToken && (
        <Box>
          {tour?.contactForm &&
            ((tour?.client && tour?.client.email) || tourEmail?.menuGetInTouch) &&
            !menu?.menuEnabled &&
            tourType !== TourType.Game && (
              <Box position="relative">
                {tour?.getInTouchTooltipOn && ButtonBgState.getInTouchHintOn && (
                  <div className="appointment-hint">
                    <X
                      className="fa-times-hint-icon"
                      onClick={() => closeHint('getInTouchHintOn')}
                      size={16}
                    />
                    <span>
                      {(translation && translation?.getInTouchAppointmentTooltip) || 'Get in touch'}
                    </span>
                    <ArrowRight size={16} className="fa-arrow-right-hint-icon" />
                  </div>
                )}
                <a
                  className="buttonBg"
                  onClick={() => {
                    closeHint('getInTouchHintOn');
                    toggleContactPopup();
                  }}
                >
                  <IdCard size={16} />
                </a>
              </Box>
            )}
          {tour?.appointmentsOn && !menuOpen && tourType !== TourType.Game && (
            <Box position="relative">
              {ButtonBgState.appointmentsHintOn && (
                <div className="appointment-hint">
                  <X
                    className="fa-times-hint-icon"
                    onClick={() => closeHint('appointmentsHintOn')}
                    size={16}
                  />
                  <span>{translation && translation.videoAppointmentTooltip}</span>
                  <ArrowRight size={16} className="fa-arrow-right-hint-icon" />
                </div>
              )}
              <a className="buttonBg active" onClick={toggleAppointmentsModal}>
                <Calendar size={16} />
              </a>
            </Box>
          )}
          {showCustomButton && (
            <Box position="relative">
              <a className="buttonBg" onClick={handleCustomButton}>
                <img
                  className="custom-button"
                  src={`${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/${tour.customButtonIcon}`}
                  alt=""
                />
              </a>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
